import React, { Component } from "react";
import { Row, Col, Container } from 'react-bootstrap'
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import CreateExamMadeEasy from '../components/exam_made_easy/CreateExamMadeEasy';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";


const FETCH_GLOBALS = gql` 
query($institution_id: Int!) {
    globals(institution_id: $institution_id){
        b_e_c_s_data {
            section_id
            class_id
            branch_id
            exam_id
          }
        exams{
            id
            exam
            exam_subjects{
                subject_id
                no_of_questions
            }
            avg_question_time
        }
        globalBranches{
            id
            branch_name
        }
        classes{
            id
            class
        }
        globalSections{
            id
            section_name
            exam_id
            branch_id
            category_id
        }
        subjects{
            id
            subject
            chapters{
                id
                chapter
                topics{
                    id
                    topic
                    # practice_percentage
                }
                class
            }
            state_chapters{
                id
                chapter
                exam_id
                state_topics{
                    id
                    topic
                }
                class
            }
        }
        questionTypes{
            id
            questiontype
        }
        questionTheory{
            id
            question_theory
        }
        complexity{
            id
            complexity
            
        }
    }
}

`;

const FETCH_SECTIONS = gql` 
query($institution_id: Int!) {
    getSections(institution_id: $institution_id){
        id
        section_name
        branch_id
    }
}

`;

const FETCH_EXAMSTANDARDPERCENTAGE = gql` 
query($exam_id: Int) {
    getExamStandardPercentage(exam_id: $exam_id){
        exam_id
        exam_type
        type_of_exam
        easy
        moderate
        difficult
    }
}

`;


const FETCH_EXAMSCHEDULESUBTYPES = gql` 
query($institution_id: Int!,$type: String) {
    getExamScheduleSubTypeQuestions(institution_id: $institution_id,type: $type){
        schedule_type_id
        schedule_sub_type_id
        schedule_sub_type
    }
}

`;

class ExamMadeEasy extends Component {
    constructor(props) {
        super(props)
        this.state = {
            toggled: Cookies.get("toggle")
        }
    }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    render() {
        if (Cookies.get("token") == undefined) this.props.history.push("/login");
        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        const getSections = this.props.getSections;
        const loading2 = getSections.loading;
        const error2 = getSections.error;

        const getExamScheduleSubTypeQuestions = this.props.getExamScheduleSubTypeQuestions;
        console.log("getExamScheduleSubTypeQuestions", getExamScheduleSubTypeQuestions)
        const loading4 = getExamScheduleSubTypeQuestions.loading;
        const error4 = getExamScheduleSubTypeQuestions.error;


        const getExamStandardPercentage = this.props.getExamStandardPercentage;
        const loading3 = getExamStandardPercentage.loading;
        const error3 = getExamStandardPercentage.error;



        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }
        if (error3 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }
        if (error4 !== undefined) {
            alert("Server Error. " + error4.message);
            return null;
        }

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">

                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper mb-2" style={{ minHeight: "50vh" }}>
                        {
                            loading1 ?
                                (
                                    <Container><Row className="my-3">
                                        <Col>
                                            <div class="spinner-border text-primary text-center loading-img-center"></div>
                                        </Col>
                                    </Row></Container>
                                )
                                :
                                (
                                    <CreateExamMadeEasy
                                        globals={globals.globals}
                                        getSections={getSections.getSections}
                                        getExamStandardPercentage={getExamStandardPercentage.getExamStandardPercentage}
                                        getExamScheduleSubTypeQuestions={getExamScheduleSubTypeQuestions.getExamScheduleSubTypeQuestions}
                                    />

                                )
                        }

                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}




export default withRouter(
    compose(

        graphql(FETCH_GLOBALS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    }
                }), name: "globals"
            }),
        graphql(FETCH_SECTIONS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    }
                }), name: "getSections"
            }),
        graphql(FETCH_EXAMSTANDARDPERCENTAGE,
            {
                options: props => ({
                    variables: {
                        exam_id: 0
                    }
                }), name: "getExamStandardPercentage"
            }),
        graphql(FETCH_EXAMSCHEDULESUBTYPES,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid")),
                        type: "Schedule_exam"

                    }
                }), name: "getExamScheduleSubTypeQuestions"
            }),
    )
        (ExamMadeEasy));